<template>
  <div class="checkin__last-call w-100 d-flex align-items-center justify-content-between">
    <div>
      <template>
        <Icon name="alertTriangle" width="20" class="mr-2"/>
        {{ $t('pages.checkins.last_call') }}
      </template>
    </div>
    <div>
      <b-button size="sm" class="" variant="outline">
        {{ $t('pages.checkins.last_call_btn') }}
      </b-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "InfoHdAvailableList",
  props: {
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    hdExpired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
  },
}
</script>


<style scoped>

</style>